import AbsenceList from "./AbsenceList.jsx";
export default AbsenceList;